import { ReactNode } from 'react';
import { NavItem, NavDropdownContentProps, PopoverMenuProps } from '../NavHeader.type';
import { isPopulatedNavDropdown, isPopulatedNavItem } from './utils';
import { NavLinkItemMobile } from '../navItems/NavLink/NavLinkItemMobile';
import { NavDropdownItemMobile } from '../navItems/NavDropdown/NavDropdownItemMobile';

interface Props {
    index: number;
    item: NavItem | NavDropdownContentProps | PopoverMenuProps;
    setActiveInnerDrawerIndex: (newIndex: number | null) => void;
}

export function MobileNavItems({ index, item, setActiveInnerDrawerIndex }: Props): ReactNode {
    if (isPopulatedNavItem(item)) {
        return <NavLinkItemMobile item={item} />;
    } else if (isPopulatedNavDropdown(item)) {
        return <NavDropdownItemMobile label={item.label} selectItem={() => setActiveInnerDrawerIndex(index)} />;
    }
    return null;
}
